import { SearchSite, SearchSiteApiResponse } from '@/apis/sites/types/sitesApi';

export const searchSitesFromApiAdapter = (
  sites: SearchSiteApiResponse[],
): SearchSite[] => {
  return sites.map((site) => {
    return {
      value: site.SiteID.toString(),
      label: site.SiteName,
    };
  });
};
